import React from "react";
import Card1 from "./Card1";
import "./gallery.css";

import { Box, Heading, Flex } from "@chakra-ui/react";

import techCoordinatorData from './techCoordinatorData';
import coreCoordinatorData from './coreCoordinatorData';
import culturalCoordinatorData from './culturalCoordinatorData';
import literaryCoordinatorData from './literaryCoordinatorData';
import creativeCoordinatorData from './creativeCoordinatorData';
import fineartsCoordinatorData from './fineartsCoordinatorData';

const Teams = () => {
  return (
    <>
      <Flex>
        <Box width={'100%'} align={'center'} justify={'center'}>
          <Heading textAlign={"center"} padding={"10"} color={"green.500"}>
            ORGANIZERS AND CORE TEAM
          </Heading>
          <Box minW={'350px'} direction='row' wrap='wrap' align='center' justify='center'>
            {coreCoordinatorData.map((user, index) =>
              <Card1 user={user} key={index} />
            )}
          </Box>
          <Heading textAlign={"center"} padding={"10"} color={"blue.400"}>
            CREATIVE HEADS
          </Heading>
          <Box minW={'350px'} direction='row' wrap='wrap' align='center' justify='center'>
            {creativeCoordinatorData.map((user, index) =>
              <Card1 user={user} key={index} />
            )}
          </Box>
          <Heading textAlign={"center"} padding={"10"} color={"orange.400"}>
            TECHNICAL TEAM
          </Heading>
          <Box minW={'350px'} direction='row' wrap='wrap' align='center' justify='center'>
            {techCoordinatorData.map((user, index) =>
              <Card1 user={user} key={index} />
            )}
          </Box>
          <Heading textAlign={"center"} padding={"10"} color={"orange.400"}>
            CULTURAL TEAM
          </Heading>
          <Box minW={'350px'} direction='row' wrap='wrap' align='center' justify='center'>
            {culturalCoordinatorData.map((user, index) =>
              <Card1 user={user} key={index} />
            )}
          </Box>
          <Heading textAlign={"center"} padding={"10"} color={"orange.400"}>
            LITERARY TEAM
          </Heading>
          <Box minW={'350px'} direction='row' wrap='wrap' align='center' justify='center'>
            {literaryCoordinatorData.map((user, index) =>
              <Card1 user={user} key={index} />
            )}
          </Box>
          <Heading textAlign={"center"} padding={"10"} color={"orange.400"}>
            FINE ARTS &amp; PHOTOGRAPHY TEAM
          </Heading>
          <Box minW={'350px'} direction='row' wrap='wrap' align='center' justify='center'>
            {fineartsCoordinatorData.map((user, index) =>
              <Card1 user={user} key={index} />
            )}
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default Teams;
